<template>
  <div class="product">
    <!-- {{ userData }} -->
    <modalcart v-model="dialog" :data="detailProduct" />
    <v-col class="pt-5" v-if="alert">Tidak ada Produk</v-col>
    <v-col class="pt-5" v-else>
      <v-row>
        <v-col cols="12" sm="5" md="4" v-if="detailLoaded">
          <v-card outlined class="rounded-lg">
            <v-col class="my-auto pa-1">
              <div class="images cursor-pointer">
                <template v-if="!loadProduct">
                  <div
                    class="d-block"
                    v-viewer="{
                      movable: false,
                      toolbar: false,
                      fullscreen: true,
                      toolbar: false,
                      title: false,
                    }"
                  >
                    <img
                      v-for="src in detailProduct.product.product_image"
                      width="100%"
                      class="rounded-lg"
                      :class="imageSelected === src ? 'd-block' : 'd-none'"
                      :src="src"
                      :key="src"
                    />
                  </div>
                </template>
                <template v-else>
                  <div class="imageLoader">
                    <v-progress-circular
                      indeterminate
                      color="green"
                    ></v-progress-circular>
                  </div>
                </template>
              </div>
            </v-col>
          </v-card>
          <div class="pt-3 product-thumbs">
            <carousel
              :loop="false"
              :nav="true"
              :dots="false"
              :responsive="{ 0: { items: 4 }, 600: { items: 4 }, 1000: { items: 4 } }"
              :mouseDrag="false"
              :margin="10"
              v-if="detailProduct.product.product_image.length > 0"
            >
              <div
                class="pr-2"
                v-for="(image, index) in detailProduct.product.product_image"
                :key="'image' + index"
              >
                <v-card
                  outlined
                  class="rounded-lg"
                  @click="(defaultImage = image), (loadFromApi = false)"
                >
                  <v-col class="my-auto pa-1">
                    <v-img
                      width="100%"
                      height="68px"
                      class="rounded-lg"
                      :src="image"
                    ></v-img>
                  </v-col>
                </v-card>
              </div>

              <template v-if="detailProduct.product.product_image.length > 4">
                <template slot="prev">
                  <v-card elevation="0" class="col-12 pa-0">
                    <v-btn
                      x-small
                      color="white"
                      elevation="3"
                      fab
                      class="prev prev-thumbs-product"
                    >
                      <v-icon color="grey darken-1">mdi-chevron-left</v-icon>
                    </v-btn>
                  </v-card>
                </template>
                <template slot="next">
                  <v-card elevation="0" class="col-12 pa-0">
                    <v-btn
                      x-small
                      color="white"
                      elevation="3"
                      fab
                      class="next next-thumbs-product"
                    >
                      <v-icon color="grey darken-1">mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-card>
                </template>
              </template>
            </carousel>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="7"
          md="8"
          class="pt-0 pt-sm-4 pb-0 pb-sm-3"
          v-if="detailLoaded"
        >
          <div class="text-body-1 text-sm-h6 font-weight-bold">
            <template v-if="detailProduct.product.product_physique !== 'ebook'">
              <span v-if="detailProduct.store.store_is_b2b == 'false'">{{
                detailProduct.product.product_name
              }}</span>
              <v-badge color="orange darken-1" content="Store Partner" inline v-else>
                <span>{{ detailProduct.product.product_name }}</span>
              </v-badge>
            </template>
            <template v-else>
              <v-badge color="red darken-1" content="E-book" inline>
                <span>{{ detailProduct.product.product_name }}</span>
              </v-badge>
            </template>
          </div>
          <div class="d-flex pt-3 pt-sm-3 grey--text text--darken-2">
            <div class="text-body-2" v-if="false">
              <star-rating :rating="detailProduct.product.product_rating"></star-rating>
            </div>
            <!-- <div class="text-body-2 pl-5"> -->
            <div class="text-body-2" v-if="detailProduct.product.product_sold_count > 0">
              <v-icon small>mdi-cart-check</v-icon>
              <span class="pl-1"
                >{{ detailProduct.product.product_sold_count | toNumber }} Terjual</span
              >
            </div>
            <div class="text-body-2 pl-4">
              <v-icon small class="mt-n1">mdi-eye</v-icon>
              <span class="pl-1"
                >{{ detailProduct.product.product_view_count | toNumber }} Dilihat</span
              >
            </div>
            <div
              color="red darken-1"
              class="text-body-2 pl-4"
              v-if="parseInt(productEbookIsExist) > 0"
            >
              <v-icon small class="mt-n1">mdi-book</v-icon>
              <span class="pl-1">Library</span>
            </div>
            <!-- <div class="text-body-2 pl-4 cursor-pointer" v-if="userData" @click="copyme">
              <span v-if="userData.user_network_id > 0">
                <v-icon color="primary">mdi-share-variant</v-icon>
                <span class="pl-1">Bagikan</span>
                <input type="hidden" :value="getUrlReferal()" id="inputCopy" />
              </span>
            </div>-->
          </div>
          <div class="text-h6 text-sm-h6 pt-3 font-weight-bold d-flex">
            <div>
              Rp {{ detailProduct.product.product_price | toNumber }}
              <sup
                v-if="
                  detailProduct.product.product_price !=
                  detailProduct.product.product_price_origin
                "
                class="text-decoration-line-through font-size-10 pink--text"
                >Rp {{ detailProduct.product.product_price_origin | toNumber }}</sup
              >
              <div class="text-caption">
                <span
                  v-if="detailProduct.product.product_enable_discount == '1'"
                  class="red white--text"
                  >{{ detailProduct.product.product_discount_percent | toNumber }}%</span
                >
                &nbsp;
                <strike v-if="detailProduct.product.product_enable_discount == '1'"
                  >Rp {{ detailProduct.product.product_gross | toNumber }}</strike
                >
              </div>
              <div class="text-caption" v-if="detailProduct.am.product_fee > 0">
                <b>
                  <!-- GM: Rp {{ detailProduct.am.total | toNumber }} -->
                  <!-- ({{ detailProduct.am.total_percent | toNumber }}%) -->
                </b>
              </div>
            </div>
            <div class="ml-3 left-border" v-if="detailProduct.product.product_pv > 0">
              <span class="ml-3">{{ detailProduct.product.product_pv }} PV</span>
            </div>
          </div>
          <div class="d-flex pt-5 grey--text text--darken-2">
            <div>
              <div class="text-body-2 font-weight-bold">Informasi</div>
              <div class="text-body-2 font-weight-bold">Produk</div>
            </div>
            <div class="pl-5 d-flex">
              <div class="pl-1">
                <div class="text-body-2 font-weight-bold">Berat</div>
                <div class="text-body-2">
                  {{ detailProduct.product.product_weight | toKg }}
                </div>
              </div>
            </div>
            <div class="pl-5 d-flex">
              <div class="pl-1">
                <div class="text-body-2 font-weight-bold">Stok</div>
                <div class="text-body-2" v-if="detailProduct.stock">
                  {{ detailProduct.stock.store_stock_quantity | toNoteStock }}
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex pt-5 grey--text text--darken-2">
            <div class="text-body-2 font-weight-bold my-auto">Jumlah</div>
            <v-card elevation="0" width="155" class="pl-5">
              <div class="d-flex">
                <v-btn
                  text
                  x-small
                  color="#1951EF"
                  height="35"
                  :disabled="quantityProduct < 2"
                  @click="quantityProduct--"
                >
                  <v-icon>mdi-minus-circle</v-icon>
                </v-btn>
                <v-currency-field
                  class="input-center"
                  v-model="quantityProduct"
                  dense
                  hide-details="auto"
                ></v-currency-field>
                <v-btn
                  text
                  x-small
                  color="#1951EF"
                  height="35"
                  @click="quantityProduct++"
                >
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
              </div>
            </v-card>
            <!-- <div class="pl-5 my-auto text-body-2">
							<span>tersisa<span class="px-2 font-weight-bold">45</span>buah</span>
            </div>-->
          </div>
          <div class="d-flex pt-5 grey--text text--darken-2" v-if="false">
            <div class="pr-5 my-auto">
              <div class="text-body-2 font-weight-bold text-uppercase">Pilihan</div>
              <div class="text-body-2 font-weight-bold text-uppercase">Pengiriman</div>
            </div>
            <div class="px-5 my-auto">
              <div class="text-body-2">Tujuan</div>
              <div class="text-body-2">Ongkos Kirim</div>
            </div>
            <div class="pl-5 d-none d-sm-block">
              <v-autocomplete
                dense
                hide-details
                class="mt-0 text-body-2"
                no-data-text="Tidak ada data tersedia"
                placeholder="Provinsi"
              ></v-autocomplete>
              <div class="pt-2 text-body-2">Rp 0 - Rp 10.000</div>
            </div>
          </div>
          <div class="pt-3 d-none">
            <v-row>
              <v-col cols="7 pr-0">
                <v-autocomplete
                  outlined
                  dense
                  hide-details
                  class="mt-0 text-body-2 rounded-lg"
                  no-data-text="Tidak ada data tersedia"
                  placeholder="Provinsi"
                ></v-autocomplete>
              </v-col>
              <v-col class="my-auto">
                <div class="text-body-2">Rp 0 - Rp 10.000</div>
              </v-col>
            </v-row>
          </div>
          <div class="d-none d-md-flex pt-5" v-if="detailLoaded">
            <v-btn
              :disabled="detailProduct.stock.store_stock_quantity <= 0"
              outlined
              height="60"
              width="250"
              color="black"
              class="rounded-lg"
              @click="addToCart"
            >
              <div class="font-weight-bold"><v-icon>mdi-cart-plus</v-icon></div>
            </v-btn>
            <v-btn
              :disabled="detailProduct.stock.store_stock_quantity <= 0"
              depressed
              height="60"
              width="250"
              color="#1951EF"
              class="rounded-lg ml-5 white--text"
              @click="buyProduct"
            >
              <div class="font-weight-bold">Beli Sekarang</div>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="8" class="pl-5 pt-5 d-none" v-else>Masih Loading</v-col>
      </v-row>
      <div class="pt-5">
        <v-card outlined class="psr-border rounded-lg">
          <v-row class="px-3" v-if="detailLoaded">
            <v-col cols="12" md="5">
              <v-row>
                <v-col cols="3" sm="2" md="3" class="py-0 pr-0 my-auto">
                  <v-img
                    width="100%"
                    :src="
                      detailProduct.store.store_image
                        ? detailProduct.store.store_image
                        : '/assets/seller/default-toko.svg'
                    "
                  ></v-img>
                </v-col>
                <v-col cols="9" sm="10" md="9" class="py-0">
                  <router-link
                    :to="{
                      name: 'store-detail',
                      params: { slug: detailProduct.store.store_slug },
                    }"
                    class="text-deco"
                  >
                    <div
                      class="text-uppercase black--text font-weight-bold text-subtitle-2"
                      v-if="detailProduct.store.store_is_b2b == 'false'"
                    >
                      {{ detailProduct.store.store_name }}
                    </div>
                    <v-badge
                      color="orange darken-1"
                      content="Store Partner"
                      inline
                      v-else
                    >
                      <div
                        class="text-uppercase black--text font-weight-bold text-subtitle-2"
                      >
                        {{ detailProduct.store.store_name }}
                      </div>
                    </v-badge>
                  </router-link>
                  <div class="pt-1 text-caption text-body-sm-2">
                    {{ detailProduct.store.store_province_name }}
                  </div>
                  <div class="d-flex pt-2">
                    <v-btn
                      outlined
                      large
                      color="primary"
                      class="px-2 px-md-3 rounded-lg mr-2"
                      v-if="false"
                    >
                      <v-icon>mdi-chat-processing-outline</v-icon>
                      <div
                        class="pl-sm-2 text-caption text-body-sm-2 text-capitalize font-weight-bold d-none d-md-block"
                      >
                        Kirim Pesan
                      </div>
                    </v-btn>
                    <v-btn
                      outlined
                      large
                      color="grey darken-1"
                      class="rounded-lg"
                      @click="gotoStore(detailProduct.store.store_slug)"
                    >
                      <v-icon>mdi-storefront-outline</v-icon>
                      <div
                        class="pl-sm-2 text-caption text-body-sm-2 text-capitalize font-weight-bold d-none d-md-block"
                      >
                        Lihat Toko
                      </div>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="7" class="my-auto left-border text-body-2 d-none d-md-block">
              <v-row class="pl-5">
                <v-col cols="5">
                  <v-row>
                    <v-col class="py-0 pr-0">Penilaian</v-col>
                    <v-col class="py-0 pr-0 black--text font-weight-bold"
                      >Belum ada</v-col
                    >
                  </v-row>
                  <v-row class="pt-2">
                    <v-col class="py-0 pr-0">Total Produk</v-col>
                    <v-col class="py-0 pr-0 black--text font-weight-bold">{{
                      detailProduct.store.store_total_product
                    }}</v-col>
                  </v-row>
                </v-col>
                <v-col cols="7">
                  <v-row>
                    <v-col cols="5" class="pa-0">Total Transaksi</v-col>
                    <v-col cols="7" class="pa-0 black--text font-weight-bold">{{
                      detailProduct.store.store_trx_count
                    }}</v-col>
                  </v-row>
                  <v-row class="pt-2">
                    <v-col cols="5" class="pa-0">Bergabung</v-col>
                    <v-col cols="7" class="pa-0 black--text font-weight-bold">{{
                      detailProduct.store.store_input_datetime | tanggal
                    }}</v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="px-3" v-else>
            <v-col cols="5">
              <v-row>
                <v-col cols="3" class="py-0 pr-0">
                  <v-img width="100%" src="/assets/product/default.png"></v-img>
                </v-col>
                <v-col cols="9" class="py-0">
                  <div
                    class="text-uppercase primary--text font-weight-bold text-subtitle-2"
                  >
                    <vcl :width="300" :height="40">
                      <rect x="0" y="5" rx="3" ry="3" width="100" height="15" />
                      <rect x="0" y="25" rx="3" ry="3" width="200" height="15" />
                    </vcl>
                  </div>
                  <div class="d-flex">
                    <v-btn outlined large color="primary" class="rounded-lg" v-if="false">
                      <v-icon>mdi-eye</v-icon>
                      <div class="pl-2 text-capitalize font-weight-bold">
                        Chat Penjual
                      </div>
                    </v-btn>
                    <v-btn outlined large color="grey darken-1" class="rounded-lg">
                      <v-icon>mdi-storefront-outline</v-icon>
                      <div
                        class="pl-sm-2 text-caption text-body-sm-2 text-capitalize font-weight-bold d-none d-md-block"
                      >
                        Lihat Toko
                      </div>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="7" class="my-auto left-border text-body-2 d-none d-md-block">
              <v-row class="pl-5">
                <v-col cols="5">
                  <v-row>
                    <v-col class="py-0 pr-0">Penilaian</v-col>
                    <v-col class="py-0 pr-0 primary--text font-weight-bold">
                      <vcl :width="150" :height="25">
                        <rect x="0" y="0" rx="3" ry="3" width="105" height="25" />
                      </vcl>
                    </v-col>
                  </v-row>
                  <v-row class="pt-2">
                    <v-col class="py-0 pr-0">Total Produk</v-col>
                    <v-col class="py-0 pr-0 primary--text font-weight-bold">
                      <vcl :width="150" :height="25">
                        <rect x="0" y="0" rx="3" ry="3" width="105" height="25" />
                      </vcl>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="7">
                  <v-row>
                    <v-col cols="5" class="pa-0">Total Transaksi</v-col>
                    <v-col cols="7" class="pa-0 primary--text font-weight-bold">
                      <vcl :width="150" :height="15">
                        <rect x="0" y="0" rx="3" ry="3" width="75" height="15" />
                      </vcl>
                    </v-col>
                  </v-row>
                  <v-row class="pt-2">
                    <v-col cols="5" class="pa-0">Bergabung</v-col>
                    <v-col cols="7" class="pa-0 primary--text font-weight-bold">
                      <vcl :width="150" :height="15">
                        <rect x="0" y="0" rx="3" ry="3" width="75" height="15" />
                      </vcl>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <div class="pt-5">
        <v-tabs color="#1951EF" class="no-slider">
          <v-tab
            class="text-subtitle-1 text-capitalize font-weight-bold"
            @click="showTab('desc')"
            >Deskripsi Produk</v-tab
          >
          <v-tab
            class="text-subtitle-1 text-capitalize font-weight-bold"
            @click="showTab('review')"
            >Ulasan Produk ({{ productReview.length | toNumber }})</v-tab
          >
          <v-tab
            class="text-subtitle-1 text-capitalize font-weight-bold"
            @click="showTab('discuss')"
            >Diskusi Produk</v-tab
          >
        </v-tabs>
      </div>
      <div class="pt-5 pb-2" v-if="tabShow == 'desc'">
        <div class="pt-2">
          <div v-if="detailLoaded" class="text-body-2">
            <span
              class="white-space-preline"
              v-html="detailProduct.product.product_description"
              v-if="detailProduct.product.product_description"
            ></span>
            <span v-else>Produk belum memiliki deskripsi.</span>
          </div>
          <div v-else>
            <v-alert class="text-body-2" text color="primary"
              >Belum ada deskripsi</v-alert
            >
          </div>
        </div>
      </div>
      <div class="pt-5 pb-2" v-if="tabShow == 'review'">
        <div class="pt-2">
          <div class="text-body-2" v-if="productReview.length > 0">
            <v-row
              v-for="review in productReview"
              :key="'review' + review.product_review_id"
            >
              <v-col cols="1">
                <v-img
                  class="rounded-circle"
                  width="80"
                  :src="review.product_review_user_image"
                ></v-img>
              </v-col>
              <v-col cols="11" class="pl-2">
                <div class="font-weight-bold">
                  {{ review.product_review_user_name }}
                  {{ parseInt(review.product_review_rating) }}
                </div>
                <div class="pt-1">
                  <star-rating :rating="review.product_review_rating"></star-rating>
                </div>
                <div class="pt-5">{{ review.product_review_content }}</div>
                <div class="pt-5">
                  <v-row class="mx-0" v-if="review.product_review_image.length > 0">
                    <div
                      class="pr-4"
                      v-for="(image, index) in review.product_review_image"
                      :key="'imageReview' + index"
                    >
                      <v-img class="rounded-lg" width="80" :src="image"></v-img>
                    </div>
                  </v-row>
                </div>
                <div class="pt-5 grey--text">
                  {{ review.product_review_datetime | tanggaljam }}
                </div>
              </v-col>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </div>
          <div v-else>
            <v-alert class="text-body-2" text color="#1951EF">Belum ada ulasan</v-alert>
          </div>
        </div>
      </div>
      <div class="pt-5 pb-2" v-if="tabShow == 'discuss'">
        <div class="pt-2">
          <div v-if="productDiscussion.length > 0">
            <v-card
              outlined
              class="psr-border rounded-lg"
              v-for="discuss in productDiscussion"
              :key="'discuss' + discuss.product_discussion_id"
            >
              <v-row class="px-3">
                <v-col cols="1">
                  <v-img
                    class="rounded-circle"
                    width="80"
                    :src="discuss.product_discussion_publisher_image"
                  ></v-img>
                </v-col>
                <v-col cols="11" class="pl-2">
                  <div class="font-weight-bold">
                    <span>{{ discuss.product_discussion_publisher_name }}</span>
                    <span class="pl-3 text-caption">{{
                      discuss.product_discussion_datetime | tanggaljam
                    }}</span>
                  </div>
                  <div class="pt-3">{{ discuss.product_discussion_content }}</div>
                </v-col>
                <v-col cols="12 pb-0 primary-border"></v-col>
              </v-row>
              <v-row
                class="px-3"
                v-for="childDiscuss in discuss.product_discussion_child"
                :key="'childDiscuss' + childDiscuss.product_discussion_id"
              >
                <v-col cols="1"></v-col>
                <v-col cols="1">
                  <v-img
                    class="rounded-circle"
                    width="80"
                    :src="childDiscuss.product_discussion_publisher_image"
                  ></v-img>
                </v-col>
                <v-col cols="10" class="pl-2">
                  <div class="font-weight-bold">
                    <span class="primary--text">{{
                      childDiscuss.product_discussion_publisher_name
                    }}</span>
                    <span class="pl-3 text-caption">{{
                      childDiscuss.product_discussion_datetime
                    }}</span>
                  </div>
                  <div class="pt-3">{{ childDiscuss.product_discussion_content }}</div>
                </v-col>
              </v-row>
              <v-row class="px-3 pt-2 pb-4">
                <v-col cols="1"></v-col>
                <v-col cols="1">
                  <v-img
                    class="rounded-circle"
                    width="55"
                    src="/assets/product/swiss-clock.png"
                  ></v-img>
                </v-col>
                <v-col cols="8" class="pl-2">
                  <v-text-field
                    outlined
                    placeholder="Tulis diskusimu disini"
                    class="text-body-2"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="1" class="pl-0 my-auto">
                  <v-btn text color="primary">
                    <v-icon large>mdi-share</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </div>
          <div v-else>
            <v-alert class="text-body-2" text color="primary">Belum ada diskusi</v-alert>
          </div>
        </div>
      </div>
      <div class="py-5">
        <v-divider></v-divider>
      </div>
      <ProductCarousel
        ref="byStore"
        v-if="productbyStore.length > 0"
        type="byStore"
        :product="productbyStore"
      >
      </ProductCarousel>
      <ProductCarousel
        ref="recomended"
        type="recomended"
        :product="productTrend"
        v-show="false"
      ></ProductCarousel>
    </v-col>
    <div class="mobile-add-cart d-block d-md-none">
      <v-row class="pa-3">
        <v-col cols="4" class="py-0">
          <v-btn
            block
            outlined
            height="60"
            color="#1951EF"
            class="rounded-lg bg-white"
            @click="addToCart"
          >
            <div class="text-caption font-weight-bold">
              <v-icon>mdi-cart-plus</v-icon>
            </div>
          </v-btn>
        </v-col>
        <v-col cols="8" class="pl-0 py-0">
          <v-btn
            block
            depressed
            height="60"
            color="#1951EF"
            class="rounded-lg"
            :loading="loading"
            @click="buyProduct"
          >
            <div class="text-caption font-weight-bold white--text">Beli Sekarang</div>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import ProductCarousel from "@/views/store/product/ProductCarousel";
import StarRating from "@/components/StarRating";
import { mapActions, mapState, mapMutations } from "vuex";
import authHelper from "@/helpers/auth";

export default {
  name: "Product",
  components: {
    carousel,
    ProductCarousel,
    StarRating,
  },
  data() {
    return {
      dialog: false,
      quantityProduct: 1,
      defaultImage: "",
      tabShow: "desc",
      loadFromApi: false,
      loading: false,
      loadProduct: false,
    };
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.detailProduct.product.product_description.slice(0, 200) || "",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: this.detailProduct.product.product_description.slice(0, 200) || "",
        },
        {
          vmid: "og:image",
          property: "og:image",
          content:
            this.detailProduct.product.product_image[0] ||
            `${process.env.VUE_APP_DOMAIN}/assets/icons/logo-banni.svg`,
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: `${process.env.VUE_APP_DOMAIN}/product/${this.$route.params.id}-${this.$route.params.slug}`,
        },
        { vmid: "og:title", property: "og:title", content: this.title },
      ],
    };
  },
  computed: {
    ...mapState(["pageTitle"]),
    title() {
      return `${this.pageTitle} - BanniBook.com - Online Bookstore Terlengkap untuk referensi buku Digital Marketing di Indonesia `;
    },
    ...mapState("cart", ["productEbookIsExist"]),
    ...mapState("productExternal", ["productbyStore", "productTrend", "alert"]),
    ...mapState("productDiscussion", ["productDiscussion"]),
    ...mapState("productReview", ["productReview"]),
    ...mapState("auth", ["userData"]),
    detailProduct() {
      return this.$store.state.productExternal.detailProduct;
    },
    detailLoaded() {
      return Object.keys(this.detailProduct).length > 0;
    },
    routerParams() {
      return this.$route.params.id;
    },
    imageSelected() {
      let image = "/assets/product/default.png";
      // if (this.detailLoaded) {
      if (this.defaultImage) {
        if (this.loadFromApi) {
          image = this.detailProduct.product.product_image[0]
            ? this.detailProduct.product.product_image[0]
            : image;
        } else {
          image = this.defaultImage;
        }
      } else {
        image = this.detailProduct.product.product_image[0]
          ? this.detailProduct.product.product_image[0]
          : image;
      }
      // }
      return image;
    },
  },
  methods: {
    ...mapActions("productExternal", [
      "getDetailProduct",
      "getProductExternal",
      "getMoreProductExternal",
      "getProductByStore",
      "getProductTrend",
    ]),
    ...mapActions("productDiscussion", ["getProductDiscussion"]),
    ...mapActions("productReview", ["getProductReview"]),
    ...mapActions("cart", ["addItemCart", "getCart", "checkProductEbookIsExist"]),
    ...mapMutations("productExternal", ["clearProductExternal"]),
    ...mapMutations("productDiscussion", ["clearProductDiscussion"]),
    ...mapMutations("productReview", ["clearProductReview"]),

    gotoStore(store_slug) {
      this.$router.push({ name: "store-detail", params: { slug: store_slug } });
    },
    async getDataDetail() {
      await this.$store
        .dispatch("productExternal/getDetailProduct", {
          slug: this.$route.params.slug,
          id: this.$route.params.id,
        })
        .then(async () => {
          this.$store.dispatch("setPageTitle", this.detailProduct.product.product_name);
          // document.getElementsByTagName("meta")["description"].content = await this.detailProduct.product.product_description.slice(0, 200) || '';
        });
      await this.$store.dispatch("productDiscussion/getProductDiscussion", {
        slug: this.$route.params.slug,
        id: this.$route.params.id,
      });
      await this.$store.dispatch("productReview/getProductReview", {
        slug: this.$route.params.slug,
        id: this.$route.params.id,
      });
      await this.$store.dispatch("productExternal/getProductByStore", {
        id: this.detailProduct.store.store_id,
        product_id: this.$route.params.id,
      });
      await this.$store.dispatch("productExternal/getProductTrend", {
        product_id: this.$route.params.id,
      });
    },
    async destroyData() {
      await this.clearProductExternal();
      await this.clearProductDiscussion();
      await this.clearProductReview();
    },
    showTab(tab) {
      this.tabShow = tab;
    },
    addToCart() {
      let params = {
        store_id: this.detailProduct.store.store_id,
        product_id: this.detailProduct.product.product_id,
        product_name: this.detailProduct.product.product_name,
        quantity: this.quantityProduct,
      };
      this.addItemCart(params)
        .then(() => {
          this.dialog = true;
          this.getCart();
        })
        .catch(() => {
          return false;
        });
    },
    buyProduct() {
      this.loading = true;
      let params = {
        store_id: this.detailProduct.store.store_id,
        product_id: this.detailProduct.product.product_id,
        product_name: this.detailProduct.product.product_name,
        quantity: this.quantityProduct,
      };
      this.addItemCart(params)
        .then(() => {
          this.$router.push({ name: "cart" });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          return false;
        });
    },
    changeProduct(id, slug) {
      this.$router.replace({
        name: "product-detail",
        params: { slug: slug, id: id },
      });
    },
    getUrlReferal() {
      return window.location + "/" + this.userData.user_mobilephone;
    },
    copyme() {
      var copyText = document.getElementById("inputCopy");
      copyText.setAttribute("type", "text");
      copyText.select();
      try {
        document.execCommand("copy");
        setTimeout(() => {
          this.$store.commit("makeAlert", {
            code: "success",
            type: "success",
            message: "Tautan berhasil disalin",
            show: true,
          });
        }, 300);
      } catch (err) {
        alert("Oops, tidak dapat menyalin");
      }
      copyText.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
  },
  async beforeCreate() {
    await this.$store
      .dispatch("productExternal/getDetailProduct", {
        slug: this.$route.params.slug,
        id: this.$route.params.id,
      })
      .then(async () => {
        this.$store.dispatch("setPageTitle", this.detailProduct.product.product_name);
        // document.getElementsByTagName("meta")["description"].content = await this.detailProduct.product.product_description.slice(0, 200) || '';
      });
    await this.$store.dispatch("productDiscussion/getProductDiscussion", {
      slug: this.$route.params.slug,
      id: this.$route.params.id,
    });
    await this.$store.dispatch("productReview/getProductReview", {
      slug: this.$route.params.slug,
      id: this.$route.params.id,
    });
    await this.$store.dispatch("productExternal/getProductByStore", {
      id: this.detailProduct.store.store_id,
      product_id: this.$route.params.id,
    });
    await this.$store.dispatch("productExternal/getProductTrend", {
      product_id: this.$route.params.id,
    });
  },
  async mounted() {
    const login = authHelper.loggedIn();
    if (login) {
      let param = await {
        product_id: this.$route.params.id,
      };
      await this.$store.dispatch("cart/checkProductEbookIsExist", param);
    }
  },
  async created() {
    let referral = this.$route.params.referral;
    if (referral) {
      let splitUrl = this.$route.path.split("/");
      splitUrl.pop();
      authHelper.setReferal(referral);
      this.$router.push(splitUrl.join("/"));
    }
  },
  watch: {
    async routerParams() {
      this.loadProduct = await true;
      await this.destroyData();
      await this.getDataDetail().then(async () => {
        this.$store.dispatch(
          "setPageTitle",
          await this.detailProduct.product.product_name
        );
        this.loadFromApi = await true;
        this.loadProduct = false;
      });
    },
  },
  beforeDestroy() {
    this.destroyData();
  },
};
</script>

<style lang="scss">
.imageLoader {
  width: 360px;
  height: 370px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;
  z-index: 99;
}

.tempImage {
  opacity: 0.2;
  z-index: 1;
}
</style>
